import { useDocumentMeta } from "../hooks/useDocumentMeta";
import { LegalLayout } from "../components/LegalLayout";

export default function PolitiqueConfidentialite() {
  useDocumentMeta({
    title: "Politique de confidentialité — FOD by DMB Partners",
    description: "Politique de confidentialité de FOD by DMB Partners : traitement, conservation et protection des données personnelles conformément au RGPD.",
    canonical: "https://www.fodbydmb.com/politique-de-confidentialite",
  });
  return (
    <LegalLayout testid="privacy-page" title="Politique de confidentialité">
          <p>
            DMB Partners (SAS), éditrice du Site et propriétaire de la marque FOD, en sa qualité de responsable de traitement, accorde une grande importance à la protection des
            données à caractère personnel et tient à assurer aux Internautes visitant le Site que leur vie
            privée est protégée.
          </p>
          <p>
            Le présent document vise à informer les Internautes et les Clients des traitements de données à
            caractère personnel les concernant, c'est-à-dire des données permettant de les identifier ainsi que
            de leurs droits à l'égard de ces traitements.
          </p>
          <p>La présente « Politique de Confidentialité » distingue :</p>
          <ul>
            <li>Les <strong>« Internautes »</strong>, à savoir les personnes qui visitent simplement le présent site web conformément aux Conditions Générales d'Utilisation,</li>
            <li>Les <strong>« Clients »</strong>, à savoir les personnes qui sont liées à FOD par les Conditions Générales de Services conformément à ce document contractuel,</li>
            <li>Les <strong>« Personnes concernées »</strong>, à savoir, indistinctement un Internaute et/ou un Client.</li>
          </ul>

          <h2>Article 01. La protection des données à caractère personnel</h2>
          <p>
            Les Personnes Concernées sont informées que l'utilisation du Site donne lieu, pour FOD, à la
            collecte et au traitement automatisé de données à caractère personnel les concernant, dont
            l'utilisation est soumise aux dispositions :
          </p>
          <ul>
            <li>Du Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 relatif à la protection des personnes physiques à l'égard du traitement des données à caractère personnel et à la libre circulation de ces données, et abrogeant la directive 95/46/CE (règlement général sur la protection des données ou « RGPD »),</li>
            <li>De la loi n° 78-17 du 6 janvier 1978 relative à l'Informatique, aux Fichiers et aux Libertés modifiée.</li>
          </ul>

          <h3>1. Données à caractère personnel collectées</h3>
          <p>Les données à caractère personnel ainsi collectées et traitées sont, en particulier, les suivantes :</p>
          <ul>
            <li>Les informations fournies, par les Personnes Concernées, lors de toutes demandes d'informations, de prises de contact ou de réclamations auprès du service contact,</li>
            <li>Les informations fournies par le Client lors de la souscription aux Conditions Générales de Services,</li>
            <li>Les informations fournies lors de la souscription à la newsletter de FOD,</li>
            <li>Les réponses aux questionnaires et sondages,</li>
            <li>Les informations recueillies pour l'élaboration des statistiques et de mesures de fréquentation du Site.</li>
          </ul>
          <p>
            Les réponses obligatoires, à défaut desquelles l'Internaute ne pourra pas devenir un Client et,
            donc, accéder aux prestations des Conditions Générales de Services, sont mentionnées comme telles
            sur les questionnaires du Site.
          </p>

          <h3>2. Finalités et bases juridiques des traitements</h3>
          <p>
            Les informations ainsi recueillies font l'objet de traitements informatiques dont les finalités
            sont de permettre aux Personnes Concernées une utilisation optimisée du Site. Ces traitements
            permettent à FOD de :
          </p>
          <ul>
            <li>Gérer et traiter les demandes d'informations et de prise de contact des Personnes Concernées effectuées sur le Site,</li>
            <li>Gérer les abonnements des Personnes Concernées à la newsletter,</li>
            <li>Agréger les informations contenues dans les sondages et questionnaires,</li>
            <li>Élaborer des statistiques et des mesures de fréquentation du Site,</li>
            <li>Assurer la sécurité du Site, l'accès à leurs données personnelles par les Personnes Concernées et détecter d'éventuelles tentatives d'intrusion.</li>
          </ul>
          <p>La base juridique des traitements réalisés par FOD est la suivante :</p>
          <ul>
            <li>Les informations fournies, par les Personnes Concernées, lors de toutes demandes d'informations, de prises de contact ou de réclamations auprès du service contact : l'exécution des Conditions Générales d'Utilisation,</li>
            <li>Les informations fournies lors de l'inscription du Client : l'exécution des Conditions Générales de Services,</li>
            <li>Les informations fournies lors de la souscription à la newsletter de FOD, ainsi que les questionnaires : le consentement des Personnes Concernées,</li>
            <li>Les informations recueillies pour l'élaboration des statistiques et de mesures de fréquentation du Site : le consentement de la Personne Concernée.</li>
          </ul>

          <h4 data-testid="privacy-estimate-email">Envoi de votre estimation par e-mail et recontact</h4>
          <p data-testid="privacy-estimate-email-text">
            Lorsque vous demandez à recevoir votre estimation par e-mail, nous utilisons votre adresse et les
            réponses saisies dans le simulateur pour vous adresser cette estimation et, avec votre accord, pour vous
            recontacter au sujet de vos frais bancaires, notamment par deux e-mails de rappel au plus (environ 3
            puis 10 jours après l'envoi de l'estimation). Ce traitement repose sur votre consentement, recueilli
            au moyen de la case à cocher prévue à cet effet. Vous pouvez le retirer à tout moment via le lien « Ne
            plus recevoir ces e-mails » présent dans chaque e-mail ou en écrivant à{" "}
            <a href="mailto:contact@fodbydmb.com">contact@fodbydmb.com</a>. Ces données ne sont jamais transmises à
            votre banque ni à des tiers. Elles sont conservées au plus 3 ans après notre dernier échange.
          </p>

          <h3>3. Les droits des Personnes Concernées</h3>
          <p>
            Les Personnes Concernées disposent du droit de demander à FOD l'accès à leurs données à caractère
            personnel, leur rectification ou effacement, ou une limitation du traitement relatif à leur
            personne, ou du droit de s'opposer au traitement et du droit à la portabilité des données.
          </p>
          <p>
            Les Personnes Concernées peuvent exercer ses droits en s'adressant, par écrit, à DMB PARTNERS au
            149 avenue du Maine, 75014 Paris, France ou par courrier électronique à{" "}
            <a href="mailto:contact@fodbydmb.com">contact@fodbydmb.com</a>. Cette demande doit notamment être
            signée de la Personne Concernée et indiquer son nom.
          </p>
          <p>
            Outre les droits précédemment mentionnés, si une Personne Concernée ne souhaite plus recevoir de
            newsletters, elle pourra s'y opposer à tout moment en cliquant sur le lien prévu à cet effet,
            présent dans chaque newsletter.
          </p>
          <p>
            Enfin, les Personnes Concernées sont informées qu'elles peuvent introduire une réclamation auprès
            d'une autorité de contrôle (la CNIL en France).
          </p>

          <h3>4. Durées de conservation</h3>
          <p>Les données à caractère personnel des Personnes Concernées sont conservées de la façon suivante :</p>
          <ul>
            <li>Les données relatives à l'abonnement à la newsletter sont conservées jusqu'à désinscription.</li>
            <li>Les données recueillies des questionnaires sont conservées pour une durée de 3 ans.</li>
            <li>Les données liées à l'envoi de l'estimation par e-mail et au recontact sont conservées pour une durée de 3 ans à compter du dernier échange.</li>
            <li>Les données collectées par FOD afin de traiter toutes demandes de prise de contact sont conservées pour une durée de 3 ans à compter de la clôture de la demande.</li>
            <li>Les données collectées par FOD afin de traiter toutes demandes d'informations sont conservées pour une durée de 3 ans à compter de la clôture de la demande.</li>
            <li>Les données de connexion et/ou de navigation sont conservées pour une durée de 13 mois à compter du dépôt des cookies ou tout autre traceur dans l'équipement terminal des Personnes Concernées.</li>
          </ul>

          <h3>5. Sécurité des données à caractère personnel</h3>
          <p>
            Le respect de leur vie privée ainsi que la protection des informations personnelles que les
            Personnes Concernées transmettent à FOD sont essentielles et FOD s'efforce de les sécuriser en
            mettant en œuvre tous les moyens dont elle dispose pour préserver la sécurité des données et,
            notamment, empêcher qu'elles soient déformées, endommagées, ou que des tiers non autorisés y aient
            accès.
          </p>
          <p>
            À cet égard, le Site est disponible sous le protocole « https » uniquement dont l'objet est de
            garantir la confidentialité et l'intégrité des données envoyées par les Personnes Concernées
            (notamment des informations entrées dans les formulaires) et reçues des serveurs informatiques de
            FOD.
          </p>

          <h3>6. Destinataires des données à caractère personnel</h3>
          <p>
            L'usage des données des Personnes Concernées est exclusivement réservé à FOD et ne fait l'objet
            d'aucune transmission à des tiers destinataires à des fins commerciales.
          </p>
          <p>
            FOD précise qu'elle n'a pas l'intention de vendre ou de commercialiser les données à caractère
            personnel des Personnes Concernées.
          </p>
          <p>
            FOD peut toutefois faire appel à des « sous-traitants », au sens de la réglementation en vigueur,
            qui agiront au compte de celle-ci et sur ses seules instructions, notamment :
          </p>
          <ul>
            <li><strong>Emergent Labs Inc.</strong> (2380 Via Espada, Pleasanton, CA 94566, États-Unis) — hébergement du Site et de ses bases de données</li>
            <li><strong>Resend</strong> — envoi des emails transactionnels (formulaire de contact, notifications de simulation)</li>
            <li>
              <strong>Contentsquare SA</strong> (RCS Paris 487 873 759, 7 rue de Madrid, 75008 Paris) — analyse
              d'audience anonymisée, mesure de l'expérience utilisateur, cartes de chaleur (heatmaps) et
              rejeu de session (session replay). Contentsquare est conforme RGPD et anonymise par défaut les
              données personnelles affichées à l'écran. Plus d'informations sur{" "}
              <a href="https://contentsquare.com/privacy/" target="_blank" rel="noreferrer">
                contentsquare.com/privacy
              </a>
              .
            </li>
            <li>
              <strong>Google Ireland Ltd.</strong> (Gordon House, Barrow Street, Dublin 4, Irlande) — mesure
              d'audience via <strong>Google Analytics 4</strong> et <strong>Google Tag</strong>. Les adresses
              IP sont anonymisées avant transmission. Plus d'informations sur{" "}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
                policies.google.com/privacy
              </a>
              .
            </li>
            <li>
              <strong>LinkedIn Ireland Unlimited Company</strong> (Wilton Plaza, Wilton Place, Dublin 2,
              Irlande) — mesure d'audience publicitaire via le <strong>LinkedIn Insight Tag</strong>,
              notamment pour le suivi des conversions et la création d'audiences cibles. Plus d'informations
              sur{" "}
              <a href="https://www.linkedin.com/legal/privacy-policy" target="_blank" rel="noreferrer">
                linkedin.com/legal/privacy-policy
              </a>
              .
            </li>
          </ul>
          <p>
            Enfin, les données à caractère personnel des Personnes Concernées ne font pas l'objet d'un
            transfert en dehors de l'Union Européenne, ni de prises de décisions automatisées.
          </p>

          <h2>Article 02. L'utilisation des « cookies »</h2>
          <p>
            FOD utilise des « cookies » pour optimiser l'utilisation du Site par les Personnes Concernées.
          </p>
          <p>
            Un cookie est un petit fichier texte qui est déposé par FOD sur le disque dur des Personnes
            Concernées. Il permet au système de FOD de se souvenir de l'appareil de la Personne Concernée lors
            de la visite du Site. Les cookies utilisés par FOD ne contiennent pas de données à caractère
            personnel mais seulement un numéro d'identification anonyme et des informations relatives à la
            navigation de l'ordinateur concerné sur le Site (les pages consultées, la date et l'heure de la
            consultation, etc.) que FOD pourra lire lors des visites ultérieures.
          </p>
          <p>FOD a recours aux catégories de cookies suivantes :</p>
          <ul>
            <li><strong>Les cookies nécessaires au fonctionnement du Site</strong> : indispensables à la navigation, ces cookies permettent aux Personnes Concernées d'utiliser les fonctionnalités principales du Site (mémorisation du choix de consentement aux cookies, sécurité). Cette catégorie ne requiert pas de consentement.</li>
            <li><strong>Les cookies de mesure d'audience et d'analyse de l'expérience utilisateur</strong> : ils permettent d'analyser le comportement des Personnes Concernées de manière anonymisée — pages visitées, durée de visite, scrolls, clics, frustrations détectées, cartes de chaleur, rejeu de session, suivi des conversions publicitaires. Ces cookies sont déposés par nos sous-traitants <strong>Contentsquare</strong>, <strong>Google (Google Analytics 4 et Google Tag)</strong> et <strong>LinkedIn (Insight Tag)</strong>, et requièrent votre consentement explicite via le bandeau d'information. Les adresses IP sont anonymisées (option <code>anonymize_ip</code> activée pour Google Analytics).</li>
          </ul>
          <p>
            <strong>Aucun cookie de mesure d'audience n'est déposé tant que le consentement n'a pas été
            recueilli.</strong> Ce consentement peut être donné en cliquant sur le bouton « Accepter » qui
            figure sur le bandeau d'information s'affichant lors de la première connexion au Site. Il peut
            être retiré à tout moment en vidant les cookies de votre navigateur ou en nous contactant à{" "}
            <a href="mailto:contact@fodbydmb.com">contact@fodbydmb.com</a>.
          </p>
          <p>
            Le Site n'associe pas l'adresse IP des Personnes Concernées avec des informations permettant
            l'identification de ces dernières. Contentsquare anonymise par défaut les saisies dans les
            formulaires et toute donnée pouvant identifier une personne.
          </p>
          <p>
            Conformément à la réglementation en vigueur, le consentement recueilli par FOD auprès des Personnes
            Concernées pour l'utilisation des cookies a une durée de validité de treize (13) mois à compter
            du dépôt des cookies. À l'expiration de ce délai, le consentement de ces derniers devra être à
            nouveau recueilli par FOD.
          </p>
    </LegalLayout>
  );
}
